module.exports = __webpack_public_path__ + "static/media/cordcutter_circle.672e0df1.png";